import styled from 'styled-components/macro'
import { motion } from 'framer-motion'

export const Content = styled(motion.div)`

`

export const Title = styled(motion.h3)`
    margin: 0;
    margin-bottom: 1rem;
`

export const OptionsContainer = styled(motion.div)`

`

export const Option = styled(motion.div)`
    cursor: pointer;
    color: white;
    background-color: var(--secondary-color);
    border-radius: 10px;
    padding: 1rem 2rem;
    font-size: 1rem;
    margin: .4rem 0;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
`


// const Selector = styled.select`
//     border-top: none;
//     border-left: none;
//     border-right: none;
//     border-bottom: 2px solid black;
//     cursor: pointer;
//     font-size: 1rem;
//     font-weight: bold;
//     text-align: center;
// `

// <Selector onChange={handleClick}>
//     <option value="A">10-20</option>
//     <option value="B">21-50</option>
//     <option value="C">51-100</option>
//     <option value="D">101-200</option>
// </Selector>